export const Roles = {
  patient: 'patient',
  staff: 'staff',
  guest: 'guest',
  admin: 'admin',
  superAdmin: 'superAdmin',
};
